export default __webpack_public_path__ + "static/media/resume.852b58db.svg";